/* CSS */
import "../bootstrap/css";

/* loading & showing loading */
import loading, {
    showLoading,
    hideLoading,
    showLoadingInit,
    hideLoadingInit,
} from "../bootstrap/loading";
showLoadingInit();

// tracker.start(); // Bắt đầu theo dõi hành động người dùng và yêu cầu fetch

/* config and my-assets */
import { TimeOut, AppInfo } from "../configs/base";
import vi from "../public/vi.json";

/* 3rd-utils */
import { createI18n } from "vue-i18n";
import { locale, loadMessages } from "devextreme/localization";
import mitt from "mitt";

/* my-helpers */
import $Core from "../bootstrap/$Core";
import Helper from "./utils/Helper";
import Events from "./utils/Events";
import App from "./App";

/* app-logic */
import vuex from "./vuex";
import createRouter from "./router";

/* vue3-utils */
import { createStore } from "vuex";
import { createApp } from "vue";

import Tracker from "@openreplay/tracker";

if (process.env.NODE_ENV === "development") {
    console.log("Chế độ phát triển đang được kích hoạt");
} else {
    const tracker = new Tracker({
        projectKey: "3Ddnuad37g5iAC2bzlRA",
        ingestPoint: "https://openreplay.sonphat.org/ingest",
        defaultInputMode: 0,
        obscureInputNumbers: false,
        obscureInputEmails: false,
        obscureInputDates: false,
        obscureTextNumbers: false,
        obscureTextEmails: false,
        network: {
            capturePayload: true, // Capture HTTP payload
        },
        __DISABLE_SECURE_MODE: true,
    });
    tracker.stop();
}

// Kích hoạt Plugin
// tracker.use(
//     fetchPlugin({
//         overrideGlobal: true,
//         shouldCaptureRequestBody: true, // Ghi nhận body của request
//         shouldCaptureResponseBody: true, // Ghi nhận body của response
//     })
// );
// tracker.use(trackerAxios(axios));

import timeZones from "./utils/Timezone.js";

var momentTz = require("moment-timezone");
var moment = require("moment");

/* define 3rd-utils */
const $i18n = createI18n({
    locale: "string",
    fallbackLocale: "en",
    messages: {
        string: require("../public/string.json"),
    },
});
const emitter = mitt();

/* define my-utils */
const $Helper = new Helper($Core, emitter);

const store = createStore(vuex);
store.$Core = $Core;
store.$Helper = $Helper;
store.$i18n = $i18n;
store.startLoading = showLoading;
store.stopLoading = hideLoading;
store.$momentTz = momentTz;
store.$moment = moment;
store.$convertTimezone = (datetime, timezone) =>
    moment.tz(datetime, timeZones[timezone]).format();

/* debug */
window.$Core = $Core;
window.$store = store;
window.$Helper = $Helper;
window.$loading = loading;

/* init Events */
const $Events = new Events({ $Core: $Core, emitter: emitter, $store: store });

store.$Events = $Events;

/* main-handler */
(async function SonPhatNumberOne(app) {
    console.log("READY", await $Core.Auth.Ready());

    if (process.env.NODE_ENV === "development") {
        console.log("Chế độ phát triển đang được kích hoạt");
    } else {
        setTimeout(() => {
            window.tracker = tracker;
            tracker.setUserID(
                $Core.Auth.TokenParsed.preferred_username
                    ? $Core.Auth.TokenParsed.preferred_username +
                          "-" +
                          $Core.Auth.TokenParsed.session_state
                    : "SonPhatC&T"
            );
            tracker.setMetadata(
                "Session_ID",
                $Core.Auth.TokenParsed.session_state || null
            );
            tracker.start();
        }, 1000);
    }
    const router = createRouter($Core, $i18n, $Helper);

    app.config.globalProperties.$appInfo = AppInfo;
    app.config.globalProperties.emitter = emitter;
    app.use(router);
    app.use(moment);
    app.use($i18n);
    app.use({
        install(app) {
            let checkTimeOutLoading = null;
            let prototype = app.config.globalProperties;
            function protoDefProp(propName, getter, setter) {
                let propMap = {};
                getter && (propMap.get = getter);
                setter && (propMap.get = setter);
                Object.defineProperty(prototype, propName, propMap);
            }

            protoDefProp("$startLoading", () => {
                emitter.emit("startLoading");
            });
            protoDefProp("$stopLoading", () => {
                emitter.emit("stopLoading");
            });
            protoDefProp("$showLoading", () => {
                showLoading();
                checkTimeOutLoading = setTimeout(() => {
                    clearTimeout(checkTimeOutLoading);
                    hideLoading();
                }, TimeOut);
                return true;
            });
            protoDefProp("$hideLoading", () => {
                clearTimeout(checkTimeOutLoading);
                hideLoading();
                return true;
            });
            protoDefProp("$moment", () => moment);
            protoDefProp("$momentTz", () => momentTz);
            prototype.$convertTimezone = (datetime, timezone) => {
                return moment.tz(datetime, timeZones[timezone]).format();
            };
            protoDefProp("$Core", () => $Core);
            protoDefProp("$Helper", () => $Helper);
            protoDefProp("$Events", () => $Events);
            protoDefProp("$Nope");

            // store
            store.startLoading = () => {
                emitter.emit("startLoading");
            };
            store.stopLoading = () => {
                emitter.emit("stopLoading");
            };
            store.ThongBaoPopup = (params) => {
                emitter.emit("ThongBaoPopup", params);
            };
        },
    });

    app.use(store);

    app.mount("#app");

    loadMessages(vi);
    locale("vi");

    hideLoadingInit();
})(createApp(App, {}));
